export default "__VITE_ASSET__ef128adc__"